module.exports = __webpack_public_path__ + "assets/img/8ef01bf14139f478c46131be23ac6b8b.png";